import React, { useEffect } from "react";
import * as theme from "../theme";
import Modal from "react-modal";
import plus from "../logos/common/plus.png";
import { dndModalClosed, getDnDModalState } from "../store/components";
import { useDispatch, useSelector } from "react-redux";
import { uploadfile } from "../store/redit";

const DragAndDropModal = (props) => {
  const dndModalState = useSelector(getDnDModalState);
  const dispatch = useDispatch();
  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(dndModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);
  return (
    <div
      onDragEnter={() => {
        console.log("ebtererer");
        // setHighlighted(true);
      }}
      onDragLeave={() => {
        // setHighlighted(false);
        //dispatch(dndModalClosed());
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDrop={(e) => {
        e.preventDefault();
        console.log("dropped from outside of modal");
        dispatch(dndModalClosed());
      }}
    >
      <Modal
        isOpen={dndModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            transition: "all 400ms ease-in-out",
          },
          content: {
            height: "95vh",
            width: "100vw",
            position: "absolute",
            top: "5vh",
            left: 0,
            right: 0,
            bottom: 0,
            color: "white",
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            border: "5px dashed white",
            borderRadius: "20px",
            padding: 0,
          },
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
          onDragEnter={() => {
            // setHighlighted(true);
          }}
          onDragLeave={() => {
            // setHighlighted(false);
            dispatch(dndModalClosed());
          }}
          onDragOver={(e) => {
            e.preventDefault();
          }}
          onDrop={(e) => {
            e.preventDefault();
            let { files } = e.dataTransfer;

            dispatch(dndModalClosed());

            for (let file in files) {
              dispatch(uploadfile(files[file]));
            }
            console.log(files.length);
            // dispatch(uploadfile(files[0]));
          }}
        >
          <img
            src={plus}
            alt="Drop here"
            style={{ height: "7%", zIndex: -1 }}
          ></img>
        </div>
      </Modal>
    </div>
  );
};

export default DragAndDropModal;
